import { useEffect, useMemo, useState } from "react";
import { KpiCard, Column, VehicleCard } from "../../components/productionLineDashboard";
import { productionDashboardData, ProductionDashboardData } from "../../data/productionLineMock";
import { usePageNameContext } from "../../contexts/PageTitleContext";

export default function ProductionManager() {
  const [data] = useState<ProductionDashboardData>(() => productionDashboardData);
  const { setInfo } = usePageNameContext();

  const kpiItems = useMemo(() => data.kpis, [data]);
  const checkInColumn = useMemo(
    () => data.columns.find((c) => c.stage === "checkin"),
    [data.columns]
  );
  const boardColumns = useMemo(
    () => data.columns.filter((c) => c.stage !== "checkin"),
    [data.columns]
  );

  useEffect(() => {
    setInfo({
      name: "Production Manager",
      desc: "KPIs and live status across production stages and checked‑in vehicles",
    });
  }, []);

  const handleAddNote = (columnId: string) => {
    // Placeholder for future integration
    // eslint-disable-next-line no-alert
    alert(`Add Note clicked for column: ${columnId}`);
  };

  const handleRaiseAlert = (columnId: string) => {
    // Placeholder for future integration
    // eslint-disable-next-line no-alert
    alert(`Raise Alert clicked for column: ${columnId}`);
  };
  const handleOpenForm = (columnId: string) => {
    // Placeholder for future integration
    // eslint-disable-next-line no-alert
    alert(`Open Form clicked for column: ${columnId}`);
  };
  const handleOpenVideo = (columnId: string) => {
    // Placeholder for future integration
    // eslint-disable-next-line no-alert
    alert(`Open Video clicked for column: ${columnId}`);
  };

  return (
    <>

      {/* KPI bar */}
      <div className="flex flex-col gap-3 sm:flex-row sm:items-stretch">
        {kpiItems.map((kpi) => (
          <KpiCard key={kpi.id} label={kpi.label} value={kpi.value} />
        ))}
        <KpiCard label="Stations Average">
          <ul className="list-disc list-inside space-y-0.5">
            {data.stationAverages.map((s) => (
              <li key={s}>{s}</li>
            ))}
          </ul>
        </KpiCard>
        <KpiCard label="Materials">
          <ul className="list-disc list-inside space-y-0.5">
            {data.materials.map((m) => (
              <li key={m.name}>
                {m.name}: {m.value}
              </li>
            ))}
          </ul>
        </KpiCard>
      </div>

      {/* Checked-In list */}
      {checkInColumn && (
        <div className="mt-6">
          <div className="flex items-center justify-between mb-2">
            <h2 className="text-sm font-semibold text-gray-700 dark:text-gray-200">
              Checked-In
            </h2>
            <div className="text-xs text-gray-500 dark:text-gray-400">
              {checkInColumn.vehicles.length} vehicle{checkInColumn.vehicles.length !== 1 ? "s" : ""}
            </div>
          </div>
          <div className="overflow-x-auto">
            <div className="flex gap-3 min-w-full">
              {checkInColumn.vehicles.map((v) => (
                <div key={v.id} className="w-64 shrink-0">
                  <VehicleCard vehicle={v} showChecklist={false} />
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* Board */}
      <div className="mt-6 overflow-x-auto">
        <div className="flex gap-4 min-w-full">
          {boardColumns.map((col) => (
            <Column
              key={col.id}
              column={col}
              onAddNote={handleAddNote}
              onRaiseAlert={handleRaiseAlert}
              onOpenForm={handleOpenForm}
              onOpenVideo={handleOpenVideo}
            />
          ))}
        </div>
      </div>
    </>
  );
}


